export { useRequiredFormInputs } from '@src/features/orders/form-inputs/hooks/useRequiredFormInputs';
export { resolveFormInputPlaceholder } from '@src/features/orders/form-inputs/core/resolveFormInputPlaceholder';
export { TariffExtraInfoCollect } from '@src/features/orders/form-inputs/legacy/TariffExtraInfoCollect';
export { TariffExtraInfoFormInputs } from '@src/features/orders/form-inputs/legacy/TariffExtraInfoFormInputs';
export { AdditionalInfoCard } from '@src/features/orders/form-inputs/components/AdditionalInfoCard';
